// ShlokaCard.js — Clean Hierarchy, Authentic Quotes
//
// Layout (minimal, focused):
//   [Top small]   Bhagavad Gita · Chapter X · Verse Y
//   [BIG CENTER]  Modern Insight (verse-authentic, emotional)
//   [Bottom small] One-line explanation
//   [Tiny]        vedsanga.com branding

// ── Better hook generator — reads verse CONTEXT not just keywords ─────────────
// ── 100% Local hook generation — unique hook for EVERY verse ────────────────
function getHook(shloka) {
  return Promise.resolve(localHook(shloka));
}

function localHook(shloka) {
  const ch = shloka.chapter;
  const vs = shloka.verse;
  const m  = (shloka.meaning || "").toLowerCase();

  // ── Chapter 1 — Every verse unique ──────────────────────────────────────
  const ch1 = {
    1:  { hook: "Every life is its own Kurukshetra.",              simple: "Your battlefield looks different. But the struggle is just as real." },
    2:  { hook: "Even the wrong side has brave soldiers.",         simple: "Courage alone does not make a cause right. Choose your side wisely." },
    3:  { hook: "Look closer — your army is already there.",       simple: "You are not as alone as you think. Open your eyes." },
    4:  { hook: "Your allies are more powerful than you know.",    simple: "The people standing with you have more strength than you give them credit for." },
    5:  { hook: "You are never alone in your battles.",            simple: "Strength multiplies when brave hearts stand together." },
    6:  { hook: "Warriors are forged before the battle begins.",   simple: "The preparation you did in silence — this is where it shows up." },
    7:  { hook: "Know who is fighting with you.",                  simple: "In any battle, understanding your team is half the victory." },
    8:  { hook: "Some battles are won before they begin.",         simple: "When you know the strength of those beside you — fear disappears." },
    9:  { hook: "Not all strength looks the same.",                simple: "Every warrior has a different gift. Together, they become unstoppable." },
    10: { hook: "Your side is stronger than you think.",           simple: "Stop doubting your own army. They showed up. So did you." },
    11: { hook: "Protect each other — that is strategy.",          simple: "Real strength is not just attacking. It is protecting those beside you." },
    12: { hook: "The elder's roar begins everything.",             simple: "Bhishma's conch shook the sky. Sometimes courage needs one voice to start." },
    13: { hook: "When the conches blow — there is no going back.", simple: "Some moments mark the point of no return. Are you ready for yours?" },
    14: { hook: "Side by side — that is how battles are won.",     simple: "Krishna and Arjuna, together. Not alone. Never alone." },
    15: { hook: "Your voice in the battle matters.",               simple: "Every conch had a name, a person, a purpose. So do you." },
    16: { hook: "Add your voice to the roar.",                     simple: "The world needs your unique sound. Stop staying silent." },
    17: { hook: "Great warriors remember each other's names.",     simple: "Honor those who stand with you. They chose this battle too." },
    18: { hook: "Small contributions create the great roar.",      simple: "Every conch added to the sound. Your effort matters more than you know." },
    19: { hook: "Let your presence shake the world.",              simple: "When you truly show up — fully, fearlessly — the earth itself responds." },
    20: { hook: "See clearly before you act.",                     simple: "Arjuna paused. Looked. Understood. Then he asked the right question." },
    21: { hook: "The right position changes everything.",          simple: "Before the fight — find your ground. Know where you stand." },
    22: { hook: "See the full picture before you commit.",         simple: "Arjuna asked to see all sides. Wisdom always surveys before it acts." },
    23: { hook: "Know who you are truly fighting.",                simple: "Look clearly at what opposes you. Not with hate — with understanding." },
    24: { hook: "A true guide places you exactly where you need to be.", simple: "Krishna drove the chariot. Sometimes the greatest act is trusting your guide." },
    25: { hook: "Face what you have been avoiding.",               simple: "Krishna placed the chariot directly in front of those Arjuna feared seeing." },
    26: { hook: "The hardest battles are with people you love.",   simple: "Arjuna saw fathers, brothers, teachers. The sword felt heavier than ever." },
    27: { hook: "Love and duty do not always walk the same path.", simple: "Some of the most painful moments are when love and responsibility collide." },
    28: { hook: "Even the strongest break down sometimes.",        simple: "Arjuna's tears were not weakness. They were the beginning of his transformation." },
    29: { hook: "Your body knows the truth before your mind does.", simple: "The trembling hands, the heavy bow — your soul was already speaking. Listen." },
    30: { hook: "Some weights are too heavy to carry alone.",      simple: "There is no shame in dropping the bow. There is only shame in never picking it up again." },
    31: { hook: "Bad omens or just fear speaking?",                simple: "We see signs of failure when we are afraid to begin. Look again — more honestly." },
    32: { hook: "What will you gain if you lose everything that matters?", simple: "Arjuna asked the question everyone avoids. Are you brave enough to ask it too?" },
    33: { hook: "Victory means nothing if love is the price.",     simple: "Some wins are losses in disguise. Know what you are truly fighting for." },
    34: { hook: "The ones you would destroy are the ones who made you.", simple: "Teachers, fathers, uncles. Arjuna saw his own roots standing across from him." },
    35: { hook: "No kingdom is worth a family's blood.",           simple: "Arjuna refused to fight for a prize that required destroying everything he loved." },
    36: { hook: "Sin does not disappear because others commit it first.", simple: "Just because they started it does not make your retaliation righteous." },
    37: { hook: "You cannot unsee what you have seen.",            simple: "Once Arjuna saw clearly — he could not pretend it was simple anymore. Nor can you." },
    38: { hook: "Greed blinds. Love opens.",                       simple: "Duryodhana saw opportunity. Arjuna saw family. The difference is everything." },
    39: { hook: "When family falls — everything falls.",           simple: "Arjuna feared the destruction of dharma from within. The deepest fears are always domestic." },
    40: { hook: "One generation's choices shape the next.",        simple: "The corruption of family values echoes across time. What are you passing forward?" },
    41: { hook: "When values collapse, chaos follows.",            simple: "Society holds together by invisible threads of shared values. Guard them." },
    42: { hook: "Broken families create broken worlds.",           simple: "Arjuna's fear was not just personal — it was civilizational. Some fears are that big." },
    43: { hook: "Ancient wisdom is the anchor in chaos.",          simple: "When traditions are lost, people lose their sense of self. Roots matter." },
    44: { hook: "The consequences of war outlive the warriors.",   simple: "What you destroy today will take generations to rebuild. Act accordingly." },
    45: { hook: "You are a warrior without a war worth fighting.", simple: "Arjuna felt lost — his skill had no righteous use. Have you ever felt that way?" },
    46: { hook: "Sometimes standing still is its own courage.",    simple: "Arjuna chose not to fight — not from cowardice, but from love. There is a difference." },
    47: { hook: "Grief is the price of love.",                     simple: "Arjuna's sorrow was proof of how much he cared. That kind of love is sacred." },
  };

  if (ch === 1 && ch1[vs]) return ch1[vs];

  // ── Chapter 2 — Every verse unique ──────────────────────────────────────
  const ch2 = {
    1:  { hook: "Your tears are valid. Now rise.",                     simple: "Krishna did not dismiss Arjuna's pain. He felt it — then gave him a reason to stand." },
    2:  { hook: "Grief is not weakness. Giving up is.",                simple: "Feel everything. But do not let feeling become an excuse to stop." },
    3:  { hook: "Do not surrender to smallness.",                      simple: "Krishna told Arjuna: this does not suit you. Some words we all need to hear." },
    4:  { hook: "The question itself is the first step.",              simple: "Arjuna admitted confusion. That honest admission opened the door to wisdom." },
    5:  { hook: "Some choices leave marks that never heal.",           simple: "There are actions you cannot take back. Arjuna felt that weight. So will you." },
    6:  { hook: "When both paths seem wrong — stop and ask.",          simple: "Arjuna was paralyzed. That paralysis was not failure — it was the moment before wisdom." },
    7:  { hook: "Ask for guidance. That is not weakness.",             simple: "Arjuna surrendered to Krishna as a student. The wisest thing anyone can do." },
    8:  { hook: "Some problems thinking cannot solve.",                simple: "Arjuna needed wisdom — not strategy. Sometimes the question is deeper than the problem." },
    9:  { hook: "Silence is sometimes the most honest answer.",        simple: "Arjuna stopped speaking. He had run out of arguments. Only truth remained." },
    10: { hook: "The teacher smiles when the student finally breaks.", simple: "Arjuna's breakdown was the moment Krishna had been waiting for. Surrender precedes wisdom." },
    11: { hook: "Stop mourning what can never die.",                   simple: "You grieve for those who need no grief. The soul is eternal and beyond all loss." },
    12: { hook: "You have always existed. You always will.",           simple: "There was never a time when you did not exist. There never will be." },
    13: { hook: "Childhood ends. Youth ends. The soul does not.",      simple: "The body moves through phases. The one who inhabits it never changes." },
    14: { hook: "Joy and sorrow are seasons — not identities.",        simple: "They come. They go. Learn to receive them both without being destroyed by either." },
    15: { hook: "The one the storm cannot move — is free.",            simple: "Equal in pleasure and pain, unshaken by life's opposites — that is true strength." },
    16: { hook: "What is real cannot be destroyed.",                   simple: "The unreal has no existence. The real never ceases to exist. Know the difference." },
    17: { hook: "No weapon can touch what you truly are.",             simple: "The soul is indestructible. Knowing this — what exactly are you afraid of?" },
    18: { hook: "Bodies end. Beings do not.",                          simple: "Fight, rest, act — knowing that what matters most in you is untouchable." },
    19: { hook: "You cannot kill. You cannot be killed.",              simple: "He who thinks he kills and he who thinks he is killed — both are wrong." },
    20: { hook: "You were never born. You will never die.",            simple: "Unborn, eternal, ever-existing — the soul was never created and will never end." },
    21: { hook: "How can the indestructible fear destruction?",        simple: "Knowing the soul is eternal — what cause remains for grief or hesitation?" },
    22: { hook: "Death is just changing clothes.",                     simple: "As a person discards worn garments and wears new ones — the soul takes new bodies." },
    23: { hook: "Nothing real can be destroyed.",                      simple: "Fire cannot burn it. Water cannot drown it. Wind cannot dry it. Weapons cannot cut it." },
    24: { hook: "You are older than time.",                            simple: "Ancient, unborn, unchanging — this is what you truly are beneath every role you play." },
    25: { hook: "The unseen is more real than what you see.",          simple: "The soul cannot be perceived by the senses — yet it is the most real thing about you." },
    26: { hook: "Even if you believe death is final — still act.",     simple: "If the soul is born and dies, it is nature's law. Grief changes nothing. Act." },
    27: { hook: "For what is born, death is certain.",                 simple: "And for what dies, rebirth is certain. Why grieve what is inevitable?" },
    28: { hook: "All beings are unseen before birth and after death.", simple: "Only in between do they appear. The middle is what we call life. Make it count." },
    29: { hook: "The soul is the rarest mystery.",                     simple: "Some see it. Some speak of it. Most never know it. You are beginning to." },
    30: { hook: "The soul in every body cannot be killed.",            simple: "Therefore you need not grieve for any living being. This is Krishna's first promise." },
    31: { hook: "For a warrior, this is not a choice — it is a calling.", simple: "Some duties are written into your very nature. Refusing them costs you your soul." },
    32: { hook: "Some opportunities only come once.",                  simple: "This battle opened by itself like a gate to heaven. Do not let it close on you." },
    33: { hook: "Refusing duty is its own kind of failure.",           simple: "If you do not fight your own dharmic battle — you will lose far more than a war." },
    34: { hook: "Dishonor outlives the person who receives it.",       simple: "For a person of honor, disgrace is worse than death. Arjuna knew this. Do you?" },
    35: { hook: "The ones who respected you will question you.",       simple: "Inaction has consequences. Those who once called you great will fall silent." },
    36: { hook: "Your enemies are already celebrating your doubt.",    simple: "Every moment you hesitate, those who envy you grow stronger. Act." },
    37: { hook: "Either way — you cannot lose.",                       simple: "Win and you enjoy the kingdom. Fall and you attain heaven. Rise, Arjuna." },
    38: { hook: "Fight with equality — that is true yoga.",            simple: "Treat pleasure and pain, victory and defeat as equal. Then sin cannot touch you." },
    39: { hook: "Now hear the wisdom that breaks all bondage.",        simple: "Krishna shifts from philosophy to yoga — the practical art of living free." },
    40: { hook: "No step on this path is ever wasted.",                simple: "Even partial practice saves you. There is no failure in spiritual effort — only progress." },
    41: { hook: "One clear resolve — that is all you need.",           simple: "The undecided mind branches endlessly. One firm determination cuts through everything." },
    42: { hook: "Pretty words about heaven can still be a trap.",      simple: "Those who promise rewards for rituals keep you dependent. True wisdom sets you free." },
    43: { hook: "Desire is the only obstacle.",                        simple: "The minds captured by pleasure and power cannot see the clear path. Let go." },
    44: { hook: "You cannot serve two masters.",                       simple: "A mind pulled between pleasure and liberation will achieve neither fully." },
    45: { hook: "Rise above the three qualities of nature.",           simple: "Go beyond what you were born with. That is the highest human achievement." },
    46: { hook: "When you have found the ocean — why seek the well?", simple: "A person of realization no longer needs rituals. The whole is already in their hands." },
    47: { hook: "Do it. Do not expect. That is freedom.",              simple: "You have the right to act. Never to the results. This is the secret of a free life." },
    48: { hook: "Balance is the highest power.",                       simple: "Perform action with an even mind — this is called yoga. This is true skill." },
    49: { hook: "Selfish action is far below wisdom-guided action.",   simple: "Seek refuge in pure understanding. Those who act for fruits are to be pitied." },
    50: { hook: "Wisdom burns all past karma.",                        simple: "The person guided by wisdom casts off both good and bad actions. They rise above both." },
    51: { hook: "Act. Then release. That is liberation.",              simple: "The wise, freed from attachment, perform action and attain a state beyond all evil." },
    52: { hook: "The day will come when you see through scripture itself.", simple: "Beyond all the heard and yet to be heard — one day your mind will stand unmoved." },
    53: { hook: "Steady wisdom is beyond all teaching.",               simple: "When your mind no longer moves by what it hears — then you will stand in true yoga." },
    54: { hook: "What does a truly wise person look like?",            simple: "Arjuna finally asks the right question. The answer describes the person you want to become." },
    55: { hook: "True peace is not the absence of desire.",            simple: "It is the ability to remain yourself when all desires arise and pass through you." },
    56: { hook: "The storm does not disturb the ocean's depths.",      simple: "Unmoved by sorrow, not excited by joy — the steady one knows real peace." },
    57: { hook: "Attached to nothing. Devoted to everything.",         simple: "Receiving good without rejoicing, receiving evil without hating — that is wisdom." },
    58: { hook: "Withdraw from the world the way a tortoise withdraws.", simple: "Pull your senses inward, away from their objects — and wisdom becomes stable." },
    59: { hook: "Abstinence fades. Experience transforms.",            simple: "You can force the senses away — but only a taste of the divine removes the craving." },
    60: { hook: "Even the wise must guard against the senses.",        simple: "They are that powerful. They can carry away even a person of discrimination." },
    61: { hook: "Sit still. Control the senses. Fix your mind on Me.", simple: "This is the full instruction. Short. Complete. The hardest thing you will ever do." },
    62: { hook: "Anger is just desire in disguise.",                   simple: "Thinking of sense objects breeds attachment. Attachment breeds desire. Desire breeds rage." },
    63: { hook: "One moment of anger can undo everything.",            simple: "From anger comes delusion. From delusion, memory fails. Then wisdom dies." },
    64: { hook: "Self-mastery is the only real peace.",                simple: "The one who moves through the world with controlled senses — attains clarity." },
    65: { hook: "From clarity comes the end of all sorrow.",           simple: "In that peace, all pain dissolves. The serene mind becomes immediately fixed." },
    66: { hook: "Without inner peace, nothing works.",                 simple: "No reason. No meditation. No happiness. Without inner steadiness — everything fails." },
    67: { hook: "The mind that follows the senses drowns.",            simple: "As a boat on water is swept by wind — wisdom is swept away by wandering senses." },
    68: { hook: "Real strength is holding back the senses.",           simple: "The one whose senses are completely restrained from their objects — that is wisdom established." },
    69: { hook: "The sage's day begins when the world sleeps.",        simple: "What is night for all beings is wakefulness for the controlled soul — and vice versa." },
    70: { hook: "The ocean is not disturbed by rivers.",               simple: "Desires flow into the wise person like rivers into the ocean — without disturbing its peace." },
    71: { hook: "Let go of I, mine, desire — and find peace.",         simple: "The one who lives without longing, free from ego — that person alone attains peace." },
    72: { hook: "This is the path. Are you ready to walk it?",         simple: "Established in this divine consciousness — one is never deluded and at death attains liberation." },
  };

  if (ch === 2 && ch2[vs]) return ch2[vs];

  // ── Chapters 3-18 with unique verse-level hooks ──────────────────────────
  const allHooks = {
    "3_1":  { hook: "Action or renunciation — which is better?",       simple: "Arjuna finally asks directly. Krishna answers with the secret that changes everything." },
    "3_2":  { hook: "Confusing words lead to confused lives.",          simple: "When teachings seem to contradict — go deeper. The confusion is in the surface, not the truth." },
    "3_3":  { hook: "Two paths. One destination.",                      simple: "The path of knowledge and the path of action — both were given for different temperaments." },
    "3_4":  { hook: "You cannot escape action by sitting still.",       simple: "Non-action is not an option. Even breathing, thinking, existing — is action." },
    "3_5":  { hook: "No one is ever truly inactive.",                   simple: "The gunas drive everyone to act, whether they like it or not. Work with this, not against it." },
    "3_6":  { hook: "Pretending is worse than honest action.",          simple: "The one who controls action but dwells on sense objects is called a hypocrite." },
    "3_7":  { hook: "Control the mind — then act freely.",              simple: "One who controls the senses with the mind and acts without attachment — excels." },
    "3_8":  { hook: "Perform your duty — inaction feeds no one.",       simple: "Even the body's basic maintenance requires action. Action is always superior to inaction." },
    "3_9":  { hook: "Work as worship — or work as bondage.",            simple: "Work done as an offering to the divine frees you. Work done for yourself binds you." },
    "3_10": { hook: "Creation itself began with sacrifice.",            simple: "The divine created humanity through mutual giving. That reciprocity is the design of existence." },
    "3_11": { hook: "Give to the divine — receive from the divine.",    simple: "Nurture the divine forces that sustain you — and they will nurture you in return." },
    "3_12": { hook: "The gift ungiven becomes theft.",                  simple: "Receiving without giving — those who enjoy without offering — are simply thieves." },
    "3_13": { hook: "Those who cook only for themselves eat sin.",      simple: "The saintly eat what remains after offering. But the selfish consume only their own karma." },
    "3_14": { hook: "You exist because of the rain. Honor it.",         simple: "Food comes from rain. Rain comes from sacrifice. Sacrifice comes from action. You are the link." },
    "3_15": { hook: "Karma flows from the eternal.",                    simple: "Action arises from the Vedas. The Vedas flow from the eternal. The cycle is complete." },
    "3_16": { hook: "Living for yourself alone is a wasted life.",      simple: "One who does not follow this cycle of giving — lives in vain, for sense pleasure alone." },
    "3_17": { hook: "The truly self-realized have no duty left.",       simple: "For one who delights only in the self — all duties are fulfilled in simply being." },
    "3_18": { hook: "Freedom from doing and not doing.",                simple: "The self-realized neither gains by action nor loses by inaction. They are already complete." },
    "3_19": { hook: "Perform action without attachment — that is the secret.", simple: "By working without attachment, one attains the supreme. This is the entire teaching in one line." },
    "3_20": { hook: "Janaka attained perfection through action.",       simple: "Kings and sages found liberation through action — not by abandoning it. You can too." },
    "3_21": { hook: "What great people do — the world follows.",        simple: "The standards great people set become society's standards. You may be setting them now." },
    "3_22": { hook: "Even God works — for the world's sake.",           simple: "Krishna has nothing to gain from action. Yet He acts. His reason: the welfare of all beings." },
    "3_23": { hook: "If I stopped — the worlds would collapse.",        simple: "Krishna reveals something staggering: His action upholds existence. So might yours." },
    "3_24": { hook: "The leader's inaction creates chaos.",             simple: "If Krishna withdrew, worlds would be destroyed. Leaders carry more than they know." },
    "3_25": { hook: "Work as hard as the ignorant — but without their chains.", simple: "The wise work just as actively — but without attachment. Same effort, total freedom." },
    "3_26": { hook: "Do not disturb the unwise with your wisdom.",      simple: "The enlightened should not create confusion in others who are still on their own path." },
    "3_27": { hook: "Nature acts. The ego claims credit.",              simple: "All actions are performed by nature's qualities. The one who thinks 'I did this' is deluded." },
    "3_28": { hook: "See the truth of who does what.",                  simple: "The one who knows reality sees that the qualities act upon the qualities — not the self." },
    "3_29": { hook: "The wise do not disturb the slow-moving.",         simple: "Do not shake the confidence of those still attached to results. They are doing their best." },
    "3_30": { hook: "Surrender action to the divine — then act fully.", simple: "Fight without expectation, without fear, without possession. That is the entire instruction." },
    "3_31": { hook: "This teaching, when followed, brings freedom.",    simple: "Those who faithfully practice this — free from envy — are also released from karma's bonds." },
    "3_32": { hook: "Those who reject this teaching reject themselves.", simple: "Without discrimination, without faith — these people are lost. Pity them, do not judge them." },
    "3_33": { hook: "Even the wise follow their own nature.",           simple: "All beings follow their nature. What will repression accomplish? Understand your nature first." },
    "3_34": { hook: "Likes and dislikes are the oldest traps.",         simple: "Attraction and aversion lie in wait for you at every sense object. Do not be ruled by them." },
    "3_35": { hook: "Your own imperfect duty is better than another's perfection.", simple: "Doing someone else's dharma — even well — is dangerous. Your own path, however rough, is yours." },
    "3_36": { hook: "What drives a person against their own will?",     simple: "Arjuna asks the most honest question: why do I do what I do not want to do? The answer: desire." },
    "3_37": { hook: "Desire is the enemy. Know it.",                    simple: "Born of passion, all-consuming, endlessly hungry — this is the greatest adversary you will face." },
    "3_38": { hook: "The enemy hides behind beauty.",                   simple: "As fire is covered by smoke, desire covers wisdom. You cannot see clearly while wanting." },
    "3_39": { hook: "This is wisdom's eternal enemy.",                  simple: "Desire — the insatiable fire — has covered the knowledge of even the wisest. Guard against it." },
    "3_40": { hook: "The senses, mind, and intellect are where it hides.", simple: "Desire operates through your instruments. Master them — and desire loses its power over you." },
    "3_41": { hook: "Slay desire before it slays you.",                 simple: "From the very beginning — regulate the senses. Then destroy the sinful enemy called desire." },
    "3_42": { hook: "The soul is above even the intellect.",            simple: "Senses, mind, intellect — these are great. But beyond them all is the soul. Anchor there." },
    "3_43": { hook: "Know yourself — and the enemy cannot find you.",   simple: "Understanding the soul is higher than desire — steady the lower self with the higher self." },
    "4_1":  { hook: "This wisdom is older than you can imagine.",       simple: "Krishna gave this yoga to the sun at the dawn of creation. It has been waiting for you." },
    "4_2":  { hook: "Ancient wisdom breaks. But it always returns.",    simple: "Passed down through ages, this knowledge faded over time. That is why Krishna speaks again." },
    "4_3":  { hook: "You are hearing this because you were chosen.",    simple: "Krishna chose to tell Arjuna — because he was both a devotee and a friend. So are you." },
    "4_4":  { hook: "How can the eternal teach the beginning?",         simple: "Arjuna asks the obvious question. Krishna's answer reveals something about the nature of God." },
    "4_5":  { hook: "You have been here before.",                       simple: "Krishna knows all His past lives. You have had yours too. What wisdom are you carrying forward?" },
    "4_6":  { hook: "God enters the world by choice — not by force.",   simple: "The divine is unborn, imperishable — yet appears through its own mysterious power." },
    "4_7":  { hook: "When darkness rises — the divine shows up.",       simple: "Whenever righteousness declines and evil rises — I manifest Myself. Always. Without fail." },
    "4_8":  { hook: "The good are protected. The evil are checked.",    simple: "Krishna descends to deliver the righteous, destroy the wicked, and re-establish dharma." },
    "4_9":  { hook: "Know why God comes — and be free.",                simple: "One who understands the divine nature of Krishna's birth and activities — is never born again." },
    "4_10": { hook: "Many have walked this path before you.",           simple: "Freed from attachment, fear, anger — purified by wisdom — they came to Krishna. So can you." },
    "4_11": { hook: "However you approach the divine — it meets you there.", simple: "In whatever way people surrender to Krishna — He rewards them accordingly. All paths lead home." },
    "4_12": { hook: "Quick results attract quick seekers.",             simple: "People worship the gods for fast results. The fruits of such worship come quickly — and go quickly." },
    "4_13": { hook: "You were not born into your caste — you grew into it.", simple: "The four divisions were created according to quality and work — not by birth. Quality is earned." },
    "4_14": { hook: "Act freely. Claim nothing. That is divine action.", simple: "Actions do not bind Krishna because He has no desire for their fruits. This can be your way too." },
    "4_15": { hook: "The ancients acted this way — so can you.",        simple: "Perform your duty following the path of the ancients. Action with understanding is liberation." },
    "4_16": { hook: "What is action? What is inaction? Even sages are confused.", simple: "The wisest teachers have been confused by this. Understanding it will free you." },
    "4_17": { hook: "Action, inaction, wrong action — know all three.", simple: "The nature of action is deep. One who understands truly — has achieved everything." },
    "4_18": { hook: "In action — see stillness. In stillness — see action.", simple: "The one who sees this is intelligent among humans. They are already liberated while acting." },
    "4_19": { hook: "When desire disappears — action purifies.",        simple: "One whose every undertaking is free from desire and motive — is called a sage by the wise." },
    "4_20": { hook: "Do everything. Need nothing.",                     simple: "Having abandoned attachment to results — always satisfied, not dependent on anything — they act freely." },
    "4_21": { hook: "Act. But own nothing.",                            simple: "With no desire, a controlled mind, no sense of possession — performing action only with the body." },
    "4_22": { hook: "Satisfied with whatever comes — beyond all dualities.", simple: "Neither elated by gain nor depressed by loss — even in failure, such a person is not bound." },
    "4_23": { hook: "For the liberated — all karma dissolves.",         simple: "The action of one who is free — performed as sacrifice — is entirely dissolved. No trace remains." },
    "4_24": { hook: "Everything is the divine.",                        simple: "The act of offering, the fire, the offering itself — all is Brahman. This is the vision of oneness." },
    "4_25": { hook: "Many paths. One destination.",                     simple: "Some worship through rituals, some through knowledge, some through service. All reach the divine." },
    "4_26": { hook: "Every sense can become an offering.",              simple: "Some offer hearing, sight, touch — in the fire of self-restraint. Every moment becomes sacred." },
    "4_27": { hook: "Offer the self — and be free.",                    simple: "Offering all functions of the senses into the fire of the controlled mind — that is true sacrifice." },
    "4_28": { hook: "Your sacrifice does not have to be grand.",        simple: "Material, austerity, yoga, knowledge — all are forms of sacrifice. Choose yours sincerely." },
    "4_29": { hook: "Even breath can be made a meditation.",            simple: "Some offer the outgoing breath into the incoming — and vice versa. Life itself becomes yoga." },
    "4_30": { hook: "Those who offer become free.",                     simple: "Knowers of sacrifice — who have tasted its nectar — reach the ancient, eternal divine." },
    "4_31": { hook: "Without inner sacrifice — this world is not for you.", simple: "How then the next? Perform sacrifice and the nectar of immortality fills this life." },
    "4_32": { hook: "Many ways to the one truth.",                      simple: "All these sacrifices are sanctioned by the Vedas. Know this — and you will be liberated." },
    "4_33": { hook: "Knowledge sacrifice surpasses all others.",        simple: "All material sacrifices culminate in knowledge. Knowledge is the supreme purifier." },
    "4_34": { hook: "Seek the teacher. Ask the question. Serve with your whole heart.", simple: "The wise who have seen the truth will initiate you — if you approach with humility." },
    "4_35": { hook: "Once you know — you will never see the same way again.", simple: "This knowledge will take you from delusion to seeing all beings in the divine and in yourself." },
    "4_36": { hook: "Even the worst sinner can cross the ocean of sin.",simple: "The boat of knowledge carries you across all evil — no matter how dark your past." },
    "4_37": { hook: "Knowledge burns karma like fire burns wood.",       simple: "As fire reduces fuel to ash — the fire of knowledge reduces all karmic actions to nothing." },
    "4_38": { hook: "Nothing purifies like true knowledge.",            simple: "Nothing in this world equals knowledge in purity. Perfected in yoga — you find it within." },
    "4_39": { hook: "Faith opens the door. Knowledge walks through it.", simple: "The faithful and sense-controlled — devoted — quickly attain knowledge and supreme peace." },
    "4_40": { hook: "Doubt is the only real enemy.",                    simple: "The doubting soul finds no happiness in this world, the next, or beyond. Decide to trust." },
    "4_41": { hook: "Renounce through yoga. Then act fearlessly.",      simple: "One who has renounced action through yoga — who has cut doubt with knowledge — is not bound." },
    "4_42": { hook: "Cut doubt with wisdom. Rise. Act.",                simple: "Standing in yoga — rise up, Arjuna. This is the instruction. Simple. Complete. Urgent." },
    "5_1":  { hook: "Which path is better — just tell me.",            simple: "Arjuna is done with philosophy. He wants a clear answer. Krishna gives him something deeper." },
    "5_2":  { hook: "Both paths lead to freedom. But action is better for most.", simple: "Renunciation and work in devotion both lead to liberation — but devotional work is superior." },
    "5_3":  { hook: "True renunciation is freedom from opposites.",     simple: "One who neither hates nor desires anything — that person is always renounced, truly free." },
    "5_4":  { hook: "Only children see them as different paths.",       simple: "The wise see: sankhya and yoga lead to the same place. One who sees this — truly sees." },
    "5_5":  { hook: "Same summit. Different roads.",                    simple: "What is reached by knowledge is also reached by work. The destination is one. Walk your road." },
    "5_6":  { hook: "Renunciation without devotion is painful.",        simple: "Without yoga, renunciation is difficult to achieve. The devoted sage quickly reaches the divine." },
    "5_7":  { hook: "The devoted soul is never tainted by action.",     simple: "One who works in devotion — pure, self-controlled, seeing all — is never bound by what they do." },
    "5_8":  { hook: "See, hear, touch — but never claim.",              simple: "The one in divine consciousness knows: I am not doing anything. The senses interact with matter. That is all." },
    "5_9":  { hook: "Life continues. The self watches.",                simple: "Breathing, moving, speaking, sleeping — the yogi knows the senses are doing their work. Not the self." },
    "5_10": { hook: "Offer everything — and nothing sticks to you.",    simple: "One who works without attachment, offering all to the divine — sin does not touch them." },
    "5_11": { hook: "Even the body is a tool of purification.",         simple: "Yogis act with body, mind, intellect — using everything — to purify the soul." },
    "5_12": { hook: "The devoted finds peace. The greedy finds chains.", simple: "The one who surrenders fruits attains peace. The one who desires them — is bound by desire." },
    "5_13": { hook: "The soul neither acts nor causes action.",          simple: "The embodied soul rests in the city of nine gates — neither acting nor causing action." },
    "5_14": { hook: "God does not create your fate. You do.",           simple: "The divine creates neither doership nor actions nor the link with results. Your nature does." },
    "5_15": { hook: "The divine does not carry your sins or your merits.", simple: "Knowledge is covered by ignorance. That is how beings are deluded. Not by God." },
    "5_16": { hook: "When knowledge dawns — it illuminates everything.", simple: "When ignorance is destroyed by self-knowledge — it reveals the supreme like the sun reveals all." },
    "5_17": { hook: "Anchor to the truth — and never return to darkness.", simple: "Intellect absorbed in truth — self in truth — devoted to truth — you do not return." },
    "5_18": { hook: "The wise see the same soul in all.",               simple: "A learned person sees equally a scholar, a cow, an elephant, a dog, and an outcast. One soul." },
    "5_19": { hook: "Those who see equality — have already won.",       simple: "Whose mind is established in equality — they have conquered rebirth even here on earth." },
    "5_20": { hook: "Neither thrilled by joy nor broken by pain.",      simple: "Steady in Brahman, undeluded — the knower of the divine neither rejoices nor grieves." },
    "5_21": { hook: "Inner joy has no outer cause.",                    simple: "One who is not attached to external sense pleasures — finds joy within. That joy is limitless." },
    "5_22": { hook: "Sense pleasures are wombs of misery.",             simple: "They have a beginning and an end. The wise find no delight in them. They know better." },
    "5_23": { hook: "Endure desire — before it endures you.",           simple: "One who can withstand the force of lust and anger before leaving this body — is truly happy." },
    "5_24": { hook: "The yogi who is happy within is liberated.",       simple: "One who finds joy, delight, and light within — that yogi is already divine, already free." },
    "5_25": { hook: "Saints who have conquered doubts attain the divine.", simple: "Those who work for all beings — sinless, free from duality — attain liberation." },
    "5_26": { hook: "Peace is close for those who have mastered themselves.", simple: "Free from desire and anger — self-controlled, self-realized — liberation is near." },
    "5_27": { hook: "Shut out the outer world — enter the inner.",      simple: "Keeping all external objects outside, gaze between the eyebrows — equalize breath. This is the door." },
    "5_28": { hook: "Sense-controlled, free from desire, free from fear — that one is free.", simple: "The sage who has made this their state — is liberated always." },
    "5_29": { hook: "Know the divine as the recipient of all — and find peace.", simple: "Friend of all. Enjoyer of all. Sustainer of all. Knowing this — peace comes at last." },
    "6_1":  { hook: "Real renunciation is not giving up fire — it is giving up desire.", simple: "One who does not depend on results of action — though working — is a renunciant and yogi." },
    "6_2":  { hook: "Renunciation and yoga are the same thing.",        simple: "No one becomes a yogi without renouncing personal motive. They are one practice." },
    "6_3":  { hook: "For the beginner — work. For the advanced — stillness.", simple: "Action is the path for one climbing. For one who has climbed — stillness is the path." },
    "6_4":  { hook: "You have arrived when you want nothing.",          simple: "When one neither craves sense objects nor actions — then they have attained yoga." },
    "6_5":  { hook: "You are your own best friend or worst enemy.",     simple: "Elevate yourself by yourself. Do not degrade yourself. The self alone is its own friend — or foe." },
    "6_6":  { hook: "Master your mind — it becomes your ally.",         simple: "For one who has conquered the mind — it is the greatest friend. For others — the greatest enemy." },
    "6_7":  { hook: "The peaceful soul sees the same in all.",          simple: "One who has conquered the mind sees gold and stone as equal. Cold and heat. Honor and dishonor." },
    "6_8":  { hook: "When you need nothing — you already have everything.", simple: "Satisfied by knowledge — unshaken — beyond the senses — treating all things equally. This is a yogi." },
    "6_9":  { hook: "The highest yogi sees friend and enemy the same.", simple: "Indifferent to saint and sinner, friend and enemy — one who sees all equally — excels." },
    "6_10": { hook: "Alone. Controlled. Wanting nothing. That is the practice.", simple: "The yogi always practices alone — controlled in mind and body — free from desire and possession." },
    "6_11": { hook: "Make your space sacred — then sit.",              simple: "A firm seat, neither too high nor too low — in a clean place — this is the preparation." },
    "6_12": { hook: "Hold the body, mind, and senses steady — and practice.", simple: "Purify the mind. Control all functions. Focus the mind on one point. This is yoga." },
    "6_13": { hook: "Spine straight. Gaze steady. Wander nowhere.",    simple: "Hold the body, neck, and head erect. Look at the tip of the nose. Still. Focused." },
    "6_14": { hook: "Fearless. Celibate. Controlled. Devoted. That is the meditation seat.", simple: "Peaceful, fearless, firm in celibacy — sit in meditation thinking of the divine." },
    "6_15": { hook: "The meditator who practices fully — finds peace.",  simple: "Always keeping the mind absorbed in the divine — the yogi attains supreme peace." },
    "6_16": { hook: "Too much or too little — both destroy yoga.",      simple: "Yoga is not for the one who eats too much or too little, sleeps too much or stays awake too long." },
    "6_17": { hook: "Measured life creates a free mind.",              simple: "Regulated eating, recreation, work, and sleep — yoga destroys all misery for such a person." },
    "6_18": { hook: "When the mind rests in the self — that is yoga.",  simple: "When the controlled mind rests in the self alone — free from all desires — it is called yoga." },
    "6_19": { hook: "A lamp in a windless place does not flicker.",     simple: "That is the image of the yogi's mind — controlled, unwavering, set on the divine." },
    "6_20": { hook: "In the stillness — the self sees the self.",       simple: "When the mind stops and rests — one sees the self by the self — and is satisfied within." },
    "6_21": { hook: "Infinite happiness that transcends the senses.",   simple: "Established in that state — the yogi never deviates from truth — and holds that treasure beyond all." },
    "6_22": { hook: "Once found — this treasure, no other seems worth having.", simple: "Established in that gain — not shaken even by the heaviest sorrow — this is real wealth." },
    "6_23": { hook: "Know this: yoga is the breaking of the bond with pain.", simple: "This yoga must be practiced with determination and an undiscouraged mind. Discomfort is the test." },
    "6_24": { hook: "Abandon desire — every single one — without exception.", simple: "Completely — without residue — restrain all desires born of sankalpa. Control all senses from all sides." },
    "6_25": { hook: "Withdraw gradually — little by little — toward stillness.", simple: "With intellect held in firmness — gradually withdraw. Fix the mind on the self. Think of nothing else." },
    "6_26": { hook: "Every time the mind wanders — bring it back.",     simple: "Wherever the restless, unsteady mind goes — bring it under the self's control. Again. And again." },
    "6_27": { hook: "The peaceful meditator touches the divine.",       simple: "Supreme happiness comes to the yogi whose mind is peaceful, whose passion is calmed, who is sinless." },
    "6_28": { hook: "Freed from sin — the yogi easily contacts the infinite joy.", simple: "Always keeping the mind in yoga — the yogi touches infinite happiness — contact with Brahman." },
    "6_29": { hook: "See yourself in all beings. See all beings in yourself.", simple: "One who sees the self everywhere and everything in the self — sees Me everywhere always." },
    "6_30": { hook: "The one who sees Me everywhere — I am never lost to them.", simple: "For one who sees Me in everything — I am never out of their sight. They are never out of Mine." },
    "6_31": { hook: "The yogi who sees one in all — lives in Me.",      simple: "Established in oneness, worshipping Me dwelling in all beings — that yogi lives in Me always." },
    "6_32": { hook: "Feel others' joy and pain as your own.",           simple: "The highest yogi — by comparison with the self — sees equal suffering and equal happiness in all." },
    "6_33": { hook: "The mind is too restless for this yoga.",          simple: "Arjuna says what every sincere seeker has felt: this yoga of equanimity seems impossible to maintain." },
    "6_34": { hook: "The mind is more restless than the wind.",         simple: "Turbulent, strong, obstinate — the mind is more difficult to control than the wind. Arjuna is honest." },
    "6_35": { hook: "The restless mind can be controlled — by practice and detachment.", simple: "It is difficult — but it is possible. Practice and non-attachment are the two keys." },
    "6_36": { hook: "Without self-control — yoga is a dream.",          simple: "For one with an uncontrolled mind — it is difficult. But for the self-controlled — success is possible." },
    "6_37": { hook: "What happens to the one who tries but fails?",     simple: "Arjuna asks the most human question: if someone begins this path but falls — what happens to them?" },
    "6_38": { hook: "Is the seeker who falls lost from both worlds?",   simple: "Like a torn cloud — lost from both paths? Arjuna fears this. Krishna's answer is comforting." },
    "6_39": { hook: "Remove this doubt completely — no one else can.",  simple: "Only you, Krishna, can answer this. Arjuna asks with perfect trust. So can you." },
    "6_40": { hook: "No one who does good comes to grief.",             simple: "Krishna promises: neither in this world nor the spiritual world does the fallen yogi meet ruin." },
    "6_41": { hook: "The fallen yogi is born again in a noble family.", simple: "After many years in higher realms — they are reborn among the pure and prosperous. Progress continues." },
    "6_42": { hook: "The yogi who fell is reborn as a yogi.",           simple: "Even better — they are born into a family of wise yogis. That birth is the rarest in this world." },
    "6_43": { hook: "Your past spiritual life carries forward.",         simple: "In the new birth — the divine intelligence from before is revived. They begin again from where they stopped." },
    "6_44": { hook: "Even the desire to know the divine is extraordinary.", simple: "The former practice pulls them forward irresistibly. Even asking about the divine exceeds ritual performance." },
    "6_45": { hook: "The sincere yogi — through many births — reaches the goal.", simple: "Striving with great effort — purified of all contaminations — the yogi reaches the supreme destination." },
    "6_46": { hook: "The yogi is greater than the ascetic, greater than the scholar.", simple: "Greater than those who perform severe austerities, greater than those of ritual knowledge. Be a yogi." },
    "6_47": { hook: "The greatest yogi is the one who loves.",          simple: "The highest of all yogis — with great faith — who worships Me dwelling within — that one is dearest to Me." },
  };

  const key = `${ch}_${vs}`;
  if (allHooks[key]) return allHooks[key];

  // ── Smart fallback by chapter theme ──────────────────────────────────────
  if (ch === 7)  return { hook: "Everything comes from the same source.",       simple: "All of existence — good and evil, joy and sorrow — arises from and returns to the divine." };
  if (ch === 8)  return { hook: "Your last thought shapes your next life.",      simple: "What fills your mind at the moment of death determines your next beginning." };
  if (ch === 9)  return { hook: "Love is the only key to the divine.",           simple: "Not rituals. Not knowledge alone. Pure, undivided devotion is the direct path." };
  if (ch === 10) return { hook: "Everywhere you look — there is the divine.",    simple: "In excellence, in beauty, in strength — everywhere — that is a glimpse of Krishna." };
  if (ch === 11) return { hook: "The infinite cannot be held — only loved.",     simple: "Arjuna trembled before the cosmic form. Krishna brought him back to the human face he loved." };
  if (ch === 12) return { hook: "Love God. Love all. Fear nothing.",             simple: "Of all spiritual paths — devotion is the most human, most direct, most powerful." };
  if (ch === 13) return { hook: "You are not the body. You are the witness.",    simple: "The body is the field. You are the one who knows the field. Never confuse the two." };
  if (ch === 14) return { hook: "Rise above the nature you were born with.",     simple: "Your tendencies are not your destiny. Awareness of them is the first step to freedom." };
  if (ch === 15) return { hook: "The highest truth is the simplest.",            simple: "Beyond the perishable and imperishable — there is the Supreme. That is what you seek." };
  if (ch === 16) return { hook: "You choose your nature every single day.",      simple: "Fearlessness, purity, compassion — or desire, anger, pride. Chosen moment by moment." };
  if (ch === 17) return { hook: "You are made of your faith.",                   simple: "As a person's faith is — so they are. Faith is the shape of your soul." };
  if (ch === 18) {
    if (vs === 66) return { hook: "Let go completely. He has got you.",          simple: "Abandon all dharmas. Surrender to Me alone. I will free you from all sin. Do not fear." };
    if (vs === 78) return { hook: "Where Krishna and Arjuna are — victory is certain.", simple: "Where the divine and the devoted warrior meet — prosperity, victory, righteousness follow." };
    return         { hook: "This is the end — and the beginning.",               simple: "The Gita does not end — it opens a door. You have been standing at it. Step through." };
  }

  return { hook: "The answer has always been within you.", simple: "The Gita is not giving you new wisdom. It is reminding you of what you already know." };
}


// ── Load image ────────────────────────────────────────────────────────────────
function loadImage(src) {
  return new Promise((resolve) => {
    const img   = new Image();
    img.onload  = () => resolve(img);
    img.onerror = () => resolve(null);
    img.src     = src + "?v=1";
  });
}

function pickImage(chapter, verse) {
  const images = [
    `/krishna/k1.png`, `/krishna/k2.png`, `/krishna/k3.png`,
  ];
  // Check verse-specific first
  const verseImg = `/verses/BG${chapter}_${verse}.png`;
  return { verseImg, fallbacks: images };
}

// ── Wrap text ─────────────────────────────────────────────────────────────────
function wrapText(ctx, text, maxW) {
  const words = text.split(" ");
  const lines = [];
  let   line  = "";
  for (const word of words) {
    const test = line ? line + " " + word : word;
    if (ctx.measureText(test).width <= maxW) { line = test; }
    else { if (line) lines.push(line); line = word; }
  }
  if (line) lines.push(line);
  return lines;
}

// ══════════════════════════════════════════════════════════════════════════════
// MAIN GENERATOR — Clean 3-zone layout
// ══════════════════════════════════════════════════════════════════════════════

export async function generateShlokaCard(shloka, themeIndex = 0) {
  const { hook, simple } = await getHook(shloka);

  // Load verse image
  const { verseImg, fallbacks } = pickImage(shloka.chapter, shloka.verse);
  let krishnaImg = await loadImage(verseImg);
  if (!krishnaImg) {
    const idx = ((shloka.chapter * 18) + shloka.verse) % fallbacks.length;
    krishnaImg = await loadImage(fallbacks[idx]);
  }

  return new Promise((resolve) => {
    const W = 1080, H = 1080;
    const canvas  = document.createElement("canvas");
    canvas.width  = W;
    canvas.height = H;
    const ctx     = canvas.getContext("2d");
    ctx.textAlign    = "center";
    ctx.textBaseline = "middle";

    // ── 1. Krishna background ──────────────────────────────────────────────
    if (krishnaImg) {
      const iW = krishnaImg.naturalWidth  || krishnaImg.width;
      const iH = krishnaImg.naturalHeight || krishnaImg.height;
      const scale = Math.max(W/iW, H/iH);
      const dW = iW*scale, dH = iH*scale;
      ctx.drawImage(krishnaImg, (W-dW)/2, (H-dH)/2, dW, dH);
    } else {
      const bg = ctx.createRadialGradient(W/2,H/2,0,W/2,H/2,W*0.8);
      bg.addColorStop(0,"#2a0c00"); bg.addColorStop(1,"#060200");
      ctx.fillStyle = bg; ctx.fillRect(0,0,W,H);
    }

    // ── 2. Gradient overlays ───────────────────────────────────────────────
    // Top fade — for reference text
    const topFade = ctx.createLinearGradient(0,0,0,H*0.35);
    topFade.addColorStop(0,"rgba(0,0,0,0.75)");
    topFade.addColorStop(1,"rgba(0,0,0,0)");
    ctx.fillStyle = topFade; ctx.fillRect(0,0,W,H*0.35);

    // Bottom fade — for quote + simple
    const botFade = ctx.createLinearGradient(0,H*0.42,0,H);
    botFade.addColorStop(0,"rgba(0,0,0,0)");
    botFade.addColorStop(0.2,"rgba(0,0,0,0.70)");
    botFade.addColorStop(0.5,"rgba(0,0,0,0.88)");
    botFade.addColorStop(1,  "rgba(0,0,0,0.96)");
    ctx.fillStyle = botFade; ctx.fillRect(0,H*0.42,W,H*0.58);

    // ── 3. ZONE 1: Top — OM + Reference ───────────────────────────────────
    // OM
    ctx.font        = "bold 58px serif";
    ctx.shadowColor = "rgba(255,160,40,0.8)";
    ctx.shadowBlur  = 25;
    ctx.fillStyle   = "#FFB030";
    ctx.fillText("ॐ", W/2, 68);
    ctx.shadowBlur  = 0;

    // Reference — small, elegant
    ctx.font      = "italic 24px Georgia, serif";
    ctx.fillStyle = "rgba(220,175,80,0.85)";
    ctx.shadowColor = "rgba(0,0,0,0.9)";
    ctx.shadowBlur  = 8;
    ctx.fillText(
      `Bhagavad Gita  ·  Chapter ${shloka.chapter}  ·  Verse ${shloka.verse}`,
      W/2, 118
    );
    ctx.shadowBlur = 0;

    // ── 4. ZONE 2: Sanskrit — small, aesthetic (NOT dominant) ─────────────
    const sktRaw   = (shloka.sanskrit || "").replace(/\|\|.*?\|\|/g,"").trim();
    const sktParts = sktRaw.split("|").map(p=>p.trim()).filter(p=>p.length>2);

    // Auto-size to fit — but keep small (max 34px)
    let sktSize = 34;
    ctx.font    = `${sktSize}px serif`;
    sktParts.slice(0,2).forEach(line => {
      while (ctx.measureText(line).width > 900 && sktSize > 22) {
        sktSize--;
        ctx.font = `${sktSize}px serif`;
      }
    });

    // Position Sanskrit at 54% — above the quote zone
    let sktY = Math.round(H * 0.54);
    ctx.font = `${sktSize}px serif`;
    sktParts.slice(0,2).forEach((line, i) => {
      ctx.shadowColor = "rgba(0,0,0,0.9)";
      ctx.shadowBlur  = 6;
      ctx.fillStyle   = "rgba(255,215,140,0.80)";
      ctx.fillText(line + (i===0?" |":""), W/2, sktY + i*(sktSize+8));
    });
    ctx.shadowBlur = 0;
    sktY += sktParts.slice(0,2).length * (sktSize+8) + 12;

    // ── 5. ZONE 3: BIG HOOK — the emotional center ─────────────────────────
    // Thin divider
    ctx.strokeStyle = "rgba(200,155,50,0.4)";
    ctx.lineWidth   = 1;
    ctx.beginPath(); ctx.moveTo(W/2-160,sktY); ctx.lineTo(W/2+160,sktY); ctx.stroke();
    sktY += 18;

    // Auto-size hook to fit in 2 lines max
    let hookSize = 80;
    ctx.font     = `bold ${hookSize}px Georgia, serif`;
    let hookLines = wrapText(ctx, hook, 900);

    while (hookSize > 48) {
      ctx.font  = `bold ${hookSize}px Georgia, serif`;
      const big = hookLines.length > 2 || hookLines.some(l => ctx.measureText(l).width > 920);
      if (!big) break;
      hookSize--;
      hookLines = wrapText(ctx, hook, 920);
    }

    ctx.font = `bold ${hookSize}px Georgia, serif`;
    const visHook = hookLines.slice(0,2);
    visHook.forEach((line, i) => {
      // Subtle warm glow
      ctx.shadowColor = "rgba(255,140,30,0.45)";
      ctx.shadowBlur  = 20;
      ctx.fillStyle   = "#FFFFFF";
      ctx.fillText(line, W/2, sktY + i*(hookSize+14));
    });
    ctx.shadowBlur = 0;
    sktY += visHook.length*(hookSize+14) + 18;

    // ── 6. ZONE 4: Simple meaning — subtle, not competing ─────────────────
    let simSize = 32;
    ctx.font    = `italic ${simSize}px Georgia, serif`;
    let simLines = wrapText(ctx, simple, 820);
    while (simSize > 22 && simLines.some(l=>{
      ctx.font=`italic ${simSize}px Georgia,serif`;
      return ctx.measureText(l).width>840;
    })) {
      simSize--;
      simLines = wrapText(ctx, simple, 840);
    }
    const visSim = simLines.slice(0,2);

    // Subtle separator
    ctx.strokeStyle = "rgba(200,155,50,0.25)";
    ctx.lineWidth   = 1;
    ctx.beginPath(); ctx.moveTo(W/2-200,sktY-4); ctx.lineTo(W/2+200,sktY-4); ctx.stroke();
    sktY += 10;

    ctx.font = `italic ${simSize}px Georgia, serif`;
    visSim.forEach((line,i) => {
      ctx.shadowColor = "rgba(0,0,0,0.8)";
      ctx.shadowBlur  = 6;
      ctx.fillStyle   = "rgba(255,210,140,0.85)";
      ctx.fillText(line, W/2, sktY + i*(simSize+10));
    });
    ctx.shadowBlur = 0;

    // ── 7. Branding — minimal ──────────────────────────────────────────────
    // Bottom gradient
    const brandFade = ctx.createLinearGradient(0,H-120,0,H);
    brandFade.addColorStop(0,"rgba(0,0,0,0)");
    brandFade.addColorStop(1,"rgba(0,0,0,0.5)");
    ctx.fillStyle = brandFade;
    ctx.fillRect(0,H-120,W,120);

    ctx.font      = "19px 'Trebuchet MS', sans-serif";
    ctx.fillStyle = "rgba(180,140,70,0.60)";
    ctx.shadowColor = "rgba(0,0,0,0.7)";
    ctx.shadowBlur  = 4;
    ctx.fillText("vedsanga.com  •  वेदसङ्ग", W/2, H-44);
    ctx.shadowBlur  = 0;

    // ── Return ─────────────────────────────────────────────────────────────
    canvas.toBlob((blob) => {
      resolve({ url: URL.createObjectURL(blob), canvas });
    }, "image/png", 0.95);
  });
}

export function downloadCard(url, filename) {
  const a    = document.createElement("a");
  a.href     = url;
  a.download = filename || "vedsanga-shloka.png";
  a.click();
}

// ── Day Progress Card — shareable "Day X" card for social ────────────────────
// Warm cream 1080×1080 — Instagram / WhatsApp Stories

export async function generateDayProgressCard({ day, dayName, dayTheme, journeyTitle, journeyIcon, daysChecked = [] }) {
  const W = 1080, H = 1080;
  return new Promise((resolve) => {
    const canvas  = document.createElement("canvas");
    canvas.width  = W;
    canvas.height = H;
    const ctx = canvas.getContext("2d");

    // Background
    ctx.fillStyle = "#FFFBF5";
    ctx.fillRect(0, 0, W, H);
    const glow = ctx.createRadialGradient(W/2, H*0.45, 0, W/2, H*0.45, 480);
    glow.addColorStop(0, "rgba(244,129,31,0.07)");
    glow.addColorStop(1, "rgba(255,251,245,0)");
    ctx.fillStyle = glow;
    ctx.fillRect(0, 0, W, H);

    // Gold top line
    ctx.fillStyle = "#D4AF37";
    ctx.fillRect(0, 0, W, 6);

    // OM watermark
    ctx.save();
    ctx.globalAlpha = 0.04;
    ctx.font = "bold 680px serif";
    ctx.fillStyle = "#F4811F";
    ctx.textAlign = "center"; ctx.textBaseline = "middle";
    ctx.fillText("ॐ", W/2, H*0.47);
    ctx.restore();

    ctx.textAlign = "center"; ctx.textBaseline = "middle";

    // Branding
    ctx.font = "bold 38px serif"; ctx.fillStyle = "#F4811F";
    ctx.textAlign = "left";
    ctx.fillText("ॐ", 64, 72);
    ctx.font = "22px Georgia, serif"; ctx.fillStyle = "rgba(201,149,58,0.55)";
    ctx.textAlign = "right";
    ctx.fillText("VedSanga  ·  वेदसङ्ग", W - 64, 72);
    ctx.textAlign = "center";

    // Journey icon
    ctx.font = "120px serif";
    ctx.fillText(journeyIcon || "🕉️", W/2, 240);

    // Day number — massive
    ctx.font = "bold 180px Georgia, serif";
    ctx.fillStyle = "#F4811F";
    ctx.shadowColor = "rgba(244,129,31,0.18)"; ctx.shadowBlur = 30;
    ctx.fillText(`Day ${day}`, W/2, 430);
    ctx.shadowBlur = 0;

    // Day name
    ctx.font = "bold 62px Georgia, serif";
    ctx.fillStyle = "#1C1917";
    ctx.fillText(dayName || "", W/2, 538);

    // Theme
    ctx.font = "italic 36px Georgia, serif";
    ctx.fillStyle = "#78716C";
    const words = (dayTheme || "").split(" ");
    let line = "", lines = [];
    for (const w of words) {
      const t = line ? line + " " + w : w;
      if (ctx.measureText(t).width > 800) { lines.push(line); line = w; } else line = t;
    }
    if (line) lines.push(line);
    lines.slice(0, 2).forEach((l, i) => ctx.fillText(l, W/2, 608 + i * 46));

    // Divider
    ctx.strokeStyle = "rgba(201,149,58,0.3)"; ctx.lineWidth = 1;
    ctx.beginPath(); ctx.moveTo(120, 690); ctx.lineTo(W - 120, 690); ctx.stroke();

    // Journey label
    ctx.font = "28px Georgia, serif"; ctx.fillStyle = "#C9953A";
    ctx.fillText((journeyTitle || "").toUpperCase() + "  ·  21-DAY SANKALPA CHALLENGE", W/2, 726);

    // 21 progress dots
    const dotR = 16, dotGap = 34;
    const rowW = 21 * (dotR * 2) + 20 * dotGap;
    const sx   = (W - rowW) / 2 + dotR;

    for (let i = 1; i <= 21; i++) {
      const cx   = sx + (i - 1) * (dotR * 2 + dotGap);
      const done = daysChecked.includes(i) || i < day;

      ctx.shadowBlur = done ? 8 : 0;
      ctx.shadowColor = "rgba(244,129,31,0.35)";
      ctx.fillStyle   = done ? "#F4811F" : i === day ? "rgba(244,129,31,0.3)" : "rgba(201,149,58,0.18)";
      ctx.beginPath(); ctx.arc(cx, 800, dotR, 0, Math.PI * 2); ctx.fill();
      ctx.shadowBlur = 0;

      if ([7, 14, 21].includes(i)) {
        ctx.strokeStyle = done ? "rgba(212,175,55,0.6)" : "rgba(201,149,58,0.3)";
        ctx.lineWidth   = 2;
        ctx.beginPath(); ctx.arc(cx, 800, dotR + 5, 0, Math.PI * 2); ctx.stroke();
      }
    }

    // CTA
    ctx.font = "italic 30px Georgia, serif"; ctx.fillStyle = "rgba(120,113,108,0.7)";
    ctx.fillText("vedsanga.com", W/2, 900);
    ctx.font = "bold 26px Georgia, serif"; ctx.fillStyle = "rgba(244,129,31,0.6)";
    ctx.fillText("Comment your sankalpa below 🙏", W/2, 950);

    canvas.toBlob((blob) => {
      resolve({ url: URL.createObjectURL(blob), canvas });
    }, "image/png", 0.95);
  });
}

export async function shareCardWhatsApp(cardUrl, shloka) {
  const skt   = (shloka.sanskrit||"").split("|")[0].trim();
  const short = (shloka.meaning ||"").split(/[.!?]/)[0];
  const caption =
    `🕉️ *Bhagavad Gita | Ch ${shloka.chapter}, V ${shloka.verse}*\n\n` +
    `_${skt}_\n\n"${short}"\n\n` +
    `📲 *Vedsanga* • वेदसङ्ग\n#BhagavadGita #Vedsanga #DailyShloka`;

  // Try native share with image (works on mobile)
  if (cardUrl && navigator.canShare) {
    try {
      const res  = await fetch(cardUrl);
      const blob = await res.blob();
      const file = new File([blob], `vedsanga-BG${shloka.chapter}-${shloka.verse}.png`, { type: "image/png" });
      if (navigator.canShare({ files: [file] })) {
        await navigator.share({ files: [file], text: caption });
        return;
      }
    } catch { /* fall through */ }
  }

  // Desktop fallback — download image + open WhatsApp text
  if (cardUrl) downloadCard(cardUrl, `vedsanga-BG${shloka.chapter}-${shloka.verse}.png`);
  setTimeout(() => {
    window.open(`https://wa.me/?text=${encodeURIComponent(caption)}`, "_blank");
  }, 400);
}


// ══════════════════════════════════════════════════════════════════════════════
// JOURNEY COMPLETION CARD — 1080×1920 (story format, shareable)
// ══════════════════════════════════════════════════════════════════════════════

const SCORE_WORDS = ["", "Heavy", "Lighter", "Steady", "Clear", "At Peace"];

function drawRoundRect(ctx, x, y, w, h, r) {
  ctx.beginPath();
  ctx.moveTo(x + r, y);
  ctx.lineTo(x + w - r, y);
  ctx.quadraticCurveTo(x + w, y, x + w, y + r);
  ctx.lineTo(x + w, y + h - r);
  ctx.quadraticCurveTo(x + w, y + h, x + w - r, y + h);
  ctx.lineTo(x + r, y + h);
  ctx.quadraticCurveTo(x, y + h, x, y + h - r);
  ctx.lineTo(x, y + r);
  ctx.quadraticCurveTo(x, y, x + r, y);
  ctx.closePath();
}

export async function generateJourneyCard(data) {
  const {
    title          = "Transformation",
    icon           = "🌟",
    avg_score      = 0,
    first_score    = 0,
    last_score     = 0,
    first_emotion  = "",
    last_emotion   = "",
    days_done      = 21,
    resonant_verse = null,
    ai_reflection  = "",
  } = data;

  const delta = last_score - first_score;

  return new Promise((resolve) => {
    const W = 1080;
    // Height: base + optional lines
    const hasEmo      = data.first_emotion && data.last_emotion && data.first_emotion !== data.last_emotion;
    const hasResonant = !!(data.resonant_verse && data.resonant_verse.chapter);
    const hasReflect  = !!(data.ai_reflection);
    // Reflection is 15-22 words — estimate 1-2 lines at 46px font
    const estReflLines = data.ai_reflection
      ? Math.min(2, Math.ceil(data.ai_reflection.split(" ").length / 8))
      : 0;
    const H = 1040
      + (hasEmo      ? 48  : 0)
      + (hasResonant ? 48  : 0)
      + (hasReflect  ? (estReflLines * 58) : 0);
    const canvas = document.createElement("canvas");
    canvas.width  = W;
    canvas.height = H;
    const ctx = canvas.getContext("2d");
    ctx.textAlign    = "center";
    ctx.textBaseline = "middle";

    // ─── 1. Background ───────────────────────────────────────────────────
    ctx.fillStyle = "#07040F";
    ctx.fillRect(0, 0, W, H);

    const glow1 = ctx.createRadialGradient(W*0.5, H*0.4, 0, W*0.5, H*0.4, 600);
    glow1.addColorStop(0,   "rgba(180,80,20,0.20)");
    glow1.addColorStop(0.5, "rgba(100,40,10,0.08)");
    glow1.addColorStop(1,   "rgba(0,0,0,0)");
    ctx.fillStyle = glow1;
    ctx.fillRect(0, 0, W, H);

    const glow2 = ctx.createRadialGradient(W*0.85, H*0.05, 0, W*0.85, H*0.05, 320);
    glow2.addColorStop(0, "rgba(80,40,180,0.15)");
    glow2.addColorStop(1, "rgba(0,0,0,0)");
    ctx.fillStyle = glow2;
    ctx.fillRect(0, 0, W, H);

    // ─── 2. OM watermark ─────────────────────────────────────────────────
    ctx.save();
    ctx.globalAlpha = 0.04;
    ctx.font = "bold 700px serif";
    ctx.fillStyle = "#FFB030";
    ctx.textAlign = "center";
    ctx.textBaseline = "middle";
    ctx.fillText("ॐ", W/2, H*0.48);
    ctx.globalAlpha = 1;
    ctx.restore();

    // ─── 3. Top branding bar ──────────────────────────────────────────────
    ctx.font = "bold 40px serif";
    ctx.fillStyle = "rgba(232,131,42,0.9)";
    ctx.shadowColor = "rgba(255,140,30,0.5)";
    ctx.shadowBlur = 14;
    ctx.textAlign = "left";
    ctx.textBaseline = "middle";
    ctx.fillText("ॐ", 60, 66);
    ctx.shadowBlur = 0;

    ctx.font = "24px Georgia, serif";
    ctx.fillStyle = "rgba(255,210,130,0.45)";
    ctx.textAlign = "right";
    ctx.fillText("VedSanga  ·  वेदसङ्ग", W - 60, 66);

    ctx.textAlign = "center";

    // ─── 4. Journey icon + title (compact) ───────────────────────────────
    ctx.font = "100px serif";
    ctx.fillText(icon, W/2, 190);

    ctx.font = "bold 60px Georgia, serif";
    ctx.fillStyle = "#FFFFFF";
    ctx.shadowColor = "rgba(0,0,0,0.5)";
    ctx.shadowBlur = 8;
    const titleLines = wrapText(ctx, title, 860);
    titleLines.slice(0, 1).forEach((line, i) => {
      ctx.fillText(line, W/2, 308 + i * 72);
    });
    ctx.shadowBlur = 0;

    ctx.font = "italic 28px Georgia, serif";
    ctx.fillStyle = "rgba(255,195,100,0.50)";
    ctx.fillText("21-Day Transformation Journey", W/2, 378);

    // ─── 5. Divider ───────────────────────────────────────────────────────
    const fade = (x1f, x2f, alpha) => {
      const g = ctx.createLinearGradient(W*x1f, 0, W*x2f, 0);
      g.addColorStop(0,   `rgba(201,149,58,0)`);
      g.addColorStop(0.5, `rgba(201,149,58,${alpha})`);
      g.addColorStop(1,   `rgba(201,149,58,0)`);
      return g;
    };

    ctx.strokeStyle = fade(0.1, 0.9, 0.55);
    ctx.lineWidth = 1.5;
    ctx.beginPath(); ctx.moveTo(W*0.1, 420); ctx.lineTo(W*0.9, 420); ctx.stroke();

    // ─── 6. HERO number ───────────────────────────────────────────────────
    if (delta !== 0) {
      const heroNum   = delta > 0 ? `+${delta}` : `${delta}`;
      const heroColor = delta > 0 ? "#6EE7A0" : "#F87171";
      ctx.font = "bold 200px Georgia, serif";
      ctx.fillStyle = heroColor;
      ctx.shadowColor = delta > 0 ? "rgba(110,231,160,0.3)" : "rgba(248,113,113,0.3)";
      ctx.shadowBlur = 40;
      ctx.fillText(heroNum, W/2, 570);
      ctx.shadowBlur = 0;
      ctx.font = "italic 30px Georgia, serif";
      ctx.fillStyle = "rgba(220,180,110,0.6)";
      ctx.fillText("inner score shift across 21 days", W/2, 672);
    } else {
      ctx.font = "bold 180px Georgia, serif";
      ctx.fillStyle = "#FFB030";
      ctx.shadowColor = "rgba(255,140,30,0.35)";
      ctx.shadowBlur = 40;
      ctx.fillText("21", W/2, 560);
      ctx.shadowBlur = 0;
      ctx.font = "italic 32px Georgia, serif";
      ctx.fillStyle = "rgba(220,180,110,0.6)";
      ctx.fillText("days of the Bhagavad Gita", W/2, 660);
    }

    // ─── 7. Score row: Day 1 → Day 21 ────────────────────────────────────
    const rowY = 770;
    const boxW = 220, boxH = 120, boxR = 14;
    const lx   = W/2 - 290 - boxW/2;
    const rx   = W/2 + 290 - boxW/2;

    [lx, rx].forEach((x, idx) => {
      drawRoundRect(ctx, x, rowY - boxH/2, boxW, boxH, boxR);
      ctx.fillStyle = "rgba(255,255,255,0.045)";
      ctx.fill();
      ctx.strokeStyle = "rgba(201,149,58,0.18)";
      ctx.lineWidth = 1;
      ctx.stroke();

      const score = idx === 0 ? first_score : last_score;
      const col   = idx === 0
        ? "rgba(255,200,100,0.75)"
        : delta >= 0 ? "rgba(110,231,160,0.85)" : "rgba(248,113,113,0.85)";
      const lbl   = idx === 0 ? "Day 1" : "Day 21";
      const sw    = idx === 0 ? SCORE_WORDS[first_score] : SCORE_WORDS[last_score];

      ctx.font = `bold 56px Georgia, serif`;
      ctx.fillStyle = col;
      ctx.fillText(`${score}`, x + boxW/2, rowY - 10);
      ctx.font = "24px Georgia, serif";
      ctx.fillStyle = "rgba(180,140,70,0.50)";
      ctx.fillText(lbl, x + boxW/2, rowY + 38);
      if (sw) {
        ctx.font = "italic 22px Georgia, serif";
        ctx.fillStyle = "rgba(180,140,60,0.38)";
        ctx.fillText(sw, x + boxW/2, rowY + boxH/2 + 22);
      }
    });

    ctx.font = "44px Georgia, serif";
    ctx.fillStyle = "rgba(201,149,58,0.45)";
    ctx.fillText("→", W/2, rowY);

    // ─── 8. Emotion shift (1 line) ────────────────────────────────────────
    let closeY = rowY + boxH/2 + 60;
    if (first_emotion && last_emotion && first_emotion !== last_emotion) {
      ctx.font = "italic 28px Georgia, serif";
      ctx.fillStyle = "rgba(220,185,110,0.50)";
      ctx.fillText(`"${first_emotion}"  ·  "${last_emotion}"`, W/2, closeY);
      closeY += 48;
    }

    // ─── 9. Resonant verse ────────────────────────────────────────────────
    if (resonant_verse && resonant_verse.chapter) {
      ctx.font = "italic 26px Georgia, serif";
      ctx.fillStyle = "rgba(220,185,110,0.55)";
      ctx.fillText(
        `Most resonant verse: BG ${resonant_verse.chapter}.${resonant_verse.verse}  ·  Day ${resonant_verse.day}  ·  ${"★".repeat(resonant_verse.score)}`,
        W/2, closeY
      );
      closeY += 48;
    }

    // ─── 10. Closing ──────────────────────────────────────────────────────
    ctx.strokeStyle = fade(0.2, 0.8, 0.35);
    ctx.lineWidth = 1;
    ctx.beginPath(); ctx.moveTo(W*0.2, closeY + 16); ctx.lineTo(W*0.8, closeY + 16); ctx.stroke();

    if (ai_reflection) {
      // AI reflection as main closing line
      ctx.font = "bold italic 46px Georgia, serif";
      ctx.fillStyle = "#FFFFFF";
      ctx.shadowColor = "rgba(255,255,255,0.06)";
      ctx.shadowBlur = 12;
      const reflLines = wrapText(ctx, ai_reflection, 900);
      reflLines.slice(0, 2).forEach((line, li) => {
        ctx.fillText(line, W/2, closeY + 70 + li * 58);
      });
      ctx.shadowBlur = 0;
      closeY += 60 + Math.min(reflLines.length, 2) * 58;
    } else {
      ctx.font = "bold italic 70px Georgia, serif";
      ctx.fillStyle = "#FFFFFF";
      ctx.shadowColor = "rgba(255,255,255,0.06)";
      ctx.shadowBlur = 16;
      ctx.fillText("Transformed.", W/2, closeY + 80);
      ctx.shadowBlur = 0;
      closeY += 100;
    }

    ctx.font = "22px Georgia, serif";
    ctx.fillStyle = "rgba(200,155,70,0.38)";
    ctx.fillText("vedsanga.com", W/2, closeY + 34);

    // ─── Done ─────────────────────────────────────────────────────────────
    canvas.toBlob((blob) => {
      resolve({ url: URL.createObjectURL(blob), canvas });
    }, "image/png", 0.95);
  });
}